import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useId } from 'react';
import styles from './SwiffySlider.module.scss';
import { PureButton } from '../../basics';
const Indicators = forwardRef(({ size, currentIndex, onSlideTo }, ref) => {
    const indicatorId = useId();
    return (_jsx("div", { className: styles.sliderIndicators, ref: ref, children: [...Array(size).keys()].map((_, index) => (_jsx(PureButton, { "aria-label": `Slide ${index}`, "data-active": index === currentIndex ? true : undefined, onClick: () => onSlideTo(index) }, `${indicatorId}-${index}`))) }));
});
Indicators.displayName = Indicators.name;
export { Indicators };
